/* 🤖 this file was generated by svg-to-ts */
export const mgcIconCheck2CuteFi: {
  name: 'check-2-cute-fi';
  data: string;
} = {
  name: 'check-2-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.518 3.174c-.262.071-.633.285-1.538.887-2.635 1.755-5.212 3.897-8.439 7.015l-.827.799-1.367-1.024c-.753-.565-1.476-1.076-1.61-1.138-1.096-.513-2.442-.129-3.12.891-.575.866-.544 2.043.077 2.857.158.206 4.71 4.943 5.137 5.345.958.902 2.46.891 3.479-.025.136-.122.424-.514.862-1.172 1.367-2.058 2.888-4.02 4.831-6.234 1.255-1.43 3.05-3.337 4.156-4.415.738-.719.934-1.101.933-1.82 0-.325-.019-.449-.098-.661-.249-.666-.798-1.169-1.438-1.317-.238-.054-.815-.048-1.038.012"/></svg>`
};
